const rawData = [
  { locationCoordinates: { lat: 24.3838103, lng: 71.6152179 } },

  { locationCoordinates: { lat: 24.3838103, lng: 71.6152179 } },
  { locationCoordinates: { latitude: 20.2918839, longitude: 72.9929911 } },

  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },
  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },

  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },

  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },

  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },

  { locationCoordinates: { lat: 22.22619, lng: 70.8011427 } },
  { locationCoordinates: { lat: 23.063052, lng: 70.1381383 } },
  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },
  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },

  { locationCoordinates: { lat: 23.0703718, lng: 70.1396268 } },

  { locationCoordinates: { latitude: 22.2904593, longitude: 73.2083403 } },

  { locationCoordinates: { lat: 22.2419992, lng: 68.9783819 } },

  { locationCoordinates: { lat: 20.3549097, lng: 72.9292299 } },

  { locationCoordinates: { lat: 23.5966966, lng: 72.3834193 } },
  { locationCoordinates: { latitude: 22.6267316, longitude: 70.9564418 } },
  { locationCoordinates: { latitude: 22.6267316, longitude: 70.9564418 } },

  { locationCoordinates: { latitude: 22.6267316, longitude: 70.9564418 } },
  { locationCoordinates: { latitude: 22.6267316, longitude: 70.9564418 } },
  { locationCoordinates: { lat: 23.5991831, lng: 72.3858471 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },

  { locationCoordinates: { lat: 23.066676, lng: 72.5475883 } },
  { locationCoordinates: { lat: 23.066676, lng: 72.5475883 } },
  { locationCoordinates: { lat: 23.735394, lng: 72.5757003 } },
  { locationCoordinates: { lat: 23.735394, lng: 72.5757003 } },
  { locationCoordinates: { lat: 22.2832312, lng: 73.2107281 } },
  { locationCoordinates: { lat: 23.5990333, lng: 72.3878624 } },
  { locationCoordinates: { lat: 22.9997888, lng: 72.4742609 } },
  { locationCoordinates: { lat: 23.2440115, lng: 72.4994118 } },
  { locationCoordinates: { lat: 22.3091473, lng: 70.8130272 } },
  { locationCoordinates: { latitude: 22.3091473, longitude: 70.81302 } },
  { locationCoordinates: { latitude: 22.3091473, longitude: 70.813027 } },
  { locationCoordinates: { latitude: 22.3091473, longitude: 70.813 } },

  { locationCoordinates: { lat: 20.2711039, lng: 72.8811487 } },
  { locationCoordinates: { lat: 24.385525, lng: 71.6329534 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 24.3838103, lng: 71.6152179 } },

  { locationCoordinates: { lat: 24.3838103, lng: 71.6152179 } },

  { locationCoordinates: { lat: 24.3838103, lng: 71.6152179 } },
  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },
  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },
  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },
  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },
  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },
  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },
  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },
  { locationCoordinates: { lat: 24.2479011, lng: 72.196403 } },
  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },
  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },
  { locationCoordinates: { lat: 23.0703718, lng: 70.1396268 } },
  { locationCoordinates: { lat: 23.0703718, lng: 70.1396268 } },
  { locationCoordinates: { lat: 20.6195529, lng: 72.9388306 } },
  { locationCoordinates: { latitude: 20.6195529, longitude: 72.9388306 } },
  { locationCoordinates: { lat: 20.7955003, lng: 70.703802 } },

  { locationCoordinates: { lat: 20.7955003, lng: 70.703802 } },
  { locationCoordinates: { lat: 20.7955003, lng: 70.703802 } },
  { locationCoordinates: { lat: 23.1040607, lng: 72.5272987 } },
  ,
  { locationCoordinates: { latitude: 21.117824, longitude: 73.4157213 } },
  {
    locationCoordinates: { latitude: 22.5953658, longitude: 70.96954029999999 },
  },
  { locationCoordinates: { latitude: 22.6267316, longitude: 70.9564418 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 22.9848153, lng: 72.498532 } },

  { locationCoordinates: { lat: 22.9848153, lng: 72.498532 } },

  { locationCoordinates: { lat: 22.9848153, lng: 72.498532 } },

  { locationCoordinates: { latitude: 22.289192, longitude: 70.8014429 } },

  { locationCoordinates: { latitude: 22.289192, longitude: 70.8014429 } },

  { locationCoordinates: { latitude: 22.289192, longitude: 70.8014429 } },

  { locationCoordinates: { lat: 22.9997888, lng: 72.4742609 } },

  { locationCoordinates: { lat: 21.7464813, lng: 70.62374559999999 } },

  { locationCoordinates: { lat: 21.7464813, lng: 70.62374559999999 } },

  { locationCoordinates: { lat: 23.2440115, lng: 72.4994118 } },

  { locationCoordinates: { lat: 23.2440115, lng: 72.4994118 } },

  { locationCoordinates: { latitude: 22.3091473, longitude: 70.8130272 } },

  { locationCoordinates: { latitude: 22.3091473, longitude: 70.8130272 } },

  { locationCoordinates: { latitude: 22.3091473, longitude: 70.8130272 } },

  { locationCoordinates: { latitude: 20.2711039, longitude: 72.8811487 } },

  { locationCoordinates: { lat: 21.2195581, lng: 72.8722079 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 24.383651, lng: 71.6153119 } },

  { locationCoordinates: { lat: 24.3838103, lng: 71.6152179 } },

  { locationCoordinates: { latitude: 20.2918839, longitude: 72.9929911 } },

  { locationCoordinates: { latitude: 20.2918839, longitude: 72.9929911 } },

  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },

  { locationCoordinates: { lat: 24.2479011, lng: 72.1964035 } },

  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },

  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },

  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },

  ,
  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },
  { locationCoordinates: { lat: 22.3105, lng: 73.1617 } },
  { locationCoordinates: { lat: 24.311, lng: 72.8517 } },
  { locationCoordinates: { lat: 22.13937, lng: 73.18954 } },
  { locationCoordinates: { lat: 22.25, lng: 73.148 } },
  { locationCoordinates: { lat: 20.5754, lng: 72.9261 } },
  { locationCoordinates: { lat: 23.0410364, lng: 72.5830367 } },

  { locationCoordinates: { latitude: 20.3652202, longitude: 72.9236251 } },
  { locationCoordinates: { lat: 23.0655098, lng: 72.5345047 } },
  { locationCoordinates: { lat: 23.5966966, lng: 72.381 } },
  { locationCoordinates: { latitude: 20.6029059, longitude: 72.9057492 } },
  ,
  { locationCoordinates: { lat: 23.0427672, lng: 72.6409464 } },
  { locationCoordinates: { lat: 23.85, lng: 69.65 } },

  { locationCoordinates: { lat: 21.7645, lng: 71.952 } },

  { locationCoordinates: { lat: 23.23, lng: 72.15 } },

  { locationCoordinates: { lat: 23.4932404, lng: 72.0404211 } },

  { locationCoordinates: { latitude: 20.3817409, longitude: 72.9046 } },

  { locationCoordinates: { lat: 23.2156, lng: 72.6369 } },

  { locationCoordinates: { lat: 22.9646382, lng: 72.4973783 } },

  { locationCoordinates: { lat: 23.8401691, lng: 72.1300962 } },

  { locationCoordinates: { lat: 20.5754, lng: 72.9261 } },

  { locationCoordinates: { lat: 23.5989498, lng: 72.3877855 } },

  { locationCoordinates: { lat: 23.5989498, lng: 72.3877855 } },

  { locationCoordinates: { lat: 20.5754, lng: 72.9261 } },

  {
    locationCoordinates: { latitude: 21.2386059, longitude: 81.67667200000001 },
  },

  { locationCoordinates: { lat: 22.75, lng: 75.89 } },

  { locationCoordinates: { lat: 26.43, lng: 85.13 } },

  { locationCoordinates: { lat: 22.75, lng: 75.89 } },

  { locationCoordinates: { lat: 22.75, lng: 75.89 } },

  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },

  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },

  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },

  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },

  { locationCoordinates: { lat: 23.2440115, lng: 72.4994118 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },

  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 23.2440115, lng: 72.4994118 } },

  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 22.9848153, lng: 72.4985324 } },

  { locationCoordinates: { lat: 23.2440115, lng: 72.4994118 } },
  { locationCoordinates: { lat: 23.0703718, lng: 70.1396268 } },
  { locationCoordinates: { lat: 23.0703718, lng: 70.1396268 } },
  { locationCoordinates: { lat: 23.0703718, lng: 70.1396268 } },
  { locationCoordinates: { lat: 20.7955003, lng: 70.703802 } },
  { locationCoordinates: { lat: 20.7955003, lng: 70.703802 } },
  { locationCoordinates: { lat: 20.7955003, lng: 70.703802 } },

  { locationCoordinates: { lat: 20.7955003, lng: 70.703802 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 23.2645494, lng: 72.4629976 } },

  { locationCoordinates: { lat: 22.6267316, lng: 70.9564418 } },

  { locationCoordinates: { lat: 22.2268024, lng: 70.798442 } },

  { locationCoordinates: { latitude: 22.289192, longitude: 70.8014429 } },

  { locationCoordinates: { latitude: 22.289192, longitude: 70.8014429 } },

  { locationCoordinates: { latitude: 22.289192, longitude: 70.8014429 } },

  { locationCoordinates: { latitude: 22.3091473, longitude: 70.8130272 } },

  { locationCoordinates: { lat: 22.22619, lng: 70.8011427 } },

  { locationCoordinates: { latitude: 22.3091473, longitude: 70.8130272 } },

  { locationCoordinates: { latitude: 22.6267316, longitude: 70.9564418 } },

  { locationCoordinates: { latitude: 22.3091473, longitude: 70.8130272 } },

  { locationCoordinates: { latitude: 22.3091473, longitude: 70.8130272 } },
  { locationCoordinates: { lat: 20.2918839, lng: 72.9929911 } },
  { locationCoordinates: { lat: 23.063052, lng: 70.1381383 } },
  { locationCoordinates: { lat: 23.85, lng: 69.65 } },
  { locationCoordinates: { lat: 20.3549097, lng: 72.9292299 } },
  { locationCoordinates: { latitude: 20.2918839, longitude: 72.9929911 } },
  { locationCoordinates: { lat: 20.3549097, lng: 72.9292299 } },
  { locationCoordinates: { latitude: 20.2918839, longitude: 72.9929911 } },
  { locationCoordinates: { lat: 20.3549097, lng: 72.9292299 } },
  { locationCoordinates: { lat: 20.6195529, lng: 72.9388306 } },
  { locationCoordinates: { latitude: 20.6195529, longitude: 72.9388306 } },
  { locationCoordinates: { latitude: 20.2918839, longitude: 72.9929911 } },
  { locationCoordinates: { lat: 20.5754, lng: 72.9261 } },
  { locationCoordinates: { latitude: 20.3652202, longitude: 72.9236251 } },
  { locationCoordinates: { latitude: 20.3817409, longitude: 72.9046 } },

  { locationCoordinates: { lat: 24.383651, lng: 71.6153119 } },

  { locationCoordinates: { lat: 20.7955003, lng: 70.7038 } },

  { locationCoordinates: { lat: 20.7955003, lng: 70.703802 } },

  { locationCoordinates: { lat: 21.117824, lng: 73.4157213 } },

  { locationCoordinates: { lat: 21.2195581, lng: 72.8722079 } },

  { locationCoordinates: { lat: 23.5966966, lng: 72.3834193 } },

  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 23.5966966, lng: 72.3834193 } },
  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },
  { locationCoordinates: { lat: 23.735394, lng: 72.5757003 } },
  { locationCoordinates: { lat: 23.5990333, lng: 72.3878624 } },
  { locationCoordinates: { lat: 23.5966966, lng: 72.3834193 } },
  { locationCoordinates: { lat: 23.4932404, lng: 72.0404211 } },
  { locationCoordinates: { lat: 23.8401691, lng: 72.1300962 } },
  { locationCoordinates: { lat: 23.5989498, lng: 72.3877855 } },
  { locationCoordinates: { latitude: 22.6267316, longitude: 70.9564418 } },
  { locationCoordinates: { latitude: 22.3091473, longitude: 70.8130272 } },
  { locationCoordinates: { latitude: 22.6267316, longitude: 70.9564418 } },
  { locationCoordinates: { latitude: 22.289192, longitude: 70.8014429 } },
  { locationCoordinates: { lat: 21.7464813, lng: 70.62374559999999 } },
  { locationCoordinates: { lat: 21.7464813, lng: 70.62374559999999 } },

  { locationCoordinates: { lat: 22.9848153, lng: 72.4985324 } },
  { locationCoordinates: { lat: 22.9848153, lng: 72.4985324 } },
  { locationCoordinates: { lat: 22.9997888, lng: 72.4742609 } },
  { locationCoordinates: { lat: 22.9997888, lng: 72.4742609 } },
  { locationCoordinates: { lat: 23.1040607, lng: 72.5272987 } },
  { locationCoordinates: { lat: 22.9848153, lng: 72.4985324 } },
  { locationCoordinates: { lat: 22.9997888, lng: 72.4742609 } },
  { locationCoordinates: { lat: 23.0410364, lng: 72.5830367 } },
  { locationCoordinates: { lat: 23.0655098, lng: 72.5345047 } },
  { locationCoordinates: { lat: 23.0427672, lng: 72.6409464 } },
  { locationCoordinates: { lat: 22.9646382, lng: 72.4973783 } },
  { locationCoordinates: { latitude: 22.2904593, longitude: 73.2083403 } },
  { locationCoordinates: { latitude: 22.2904593, longitude: 73.2083403 } },
  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },
  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },
  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },
  { locationCoordinates: { lat: 22.3029437, lng: 73.2307165 } },
  { locationCoordinates: { latitude: 20.2918839, longitude: 72.9929911 } },
  { locationCoordinates: { lat: 21.2195581, lng: 72.8722079 } },
  { locationCoordinates: { lat: 24.385525, lng: 71.6329534 } },
  { locationCoordinates: { lat: 24.3838103, lng: 71.6152179 } },
  { locationCoordinates: { lat: 23.1040607, lng: 72.5272987 } },
  { locationCoordinates: { lat: 22.9848153, lng: 72.4985324 } },

  { locationCoordinates: { lat: 23.1040607, lng: 72.5272987 } },

  { locationCoordinates: { lat: 23.5990764, lng: 72.3858168 } },

  { locationCoordinates: { lat: 23.7352892, lng: 72.5757978 } },

  //jamnagar cordinttes
  { locationCoordinates: { lat: 22.4707019, lng: 70.0577302 } }, // Jamnagar City Center
  { locationCoordinates: { lat: 22.4572926, lng: 70.0439784 } }, // Patel Colony
  { locationCoordinates: { lat: 22.4669987, lng: 70.0709015 } }, // Ranjit Sagar Road
  { locationCoordinates: { lat: 22.4932198, lng: 70.0861343 } }, // Digvijay Plot
  { locationCoordinates: { lat: 22.4598764, lng: 70.0853241 } }, // Gulab Nagar
  { locationCoordinates: { lat: 22.4771463, lng: 70.0331189 } }, // Joggers Park Area
  { locationCoordinates: { lat: 22.4453891, lng: 70.0604417 } }, // Shankar Tekri
  { locationCoordinates: { lat: 22.4689075, lng: 70.0926134 } }, // Valkeshwari Area
  { locationCoordinates: { lat: 22.4527812, lng: 70.0732916 } }, // Bedi Road
  { locationCoordinates: { lat: 22.4865924, lng: 70.0617738 } },
  { locationCoordinates: { lat: 21.5993907, lng: 71.2201148 } }, // Amreli City Center
  { locationCoordinates: { lat: 21.5982184, lng: 71.2258936 } }, // GIDC Area
  { locationCoordinates: { lat: 21.6104519, lng: 71.2167432 } }, // Lathi Road
  { locationCoordinates: { lat: 21.5887241, lng: 71.2298134 } }, // Jesar Road
  { locationCoordinates: { lat: 21.6032786, lng: 71.2315049 } }, // Rajula Chowk
  { locationCoordinates: { lat: 21.5954637, lng: 71.2127845 } }, // Library Road
  { locationCoordinates: { lat: 21.6061743, lng: 71.2053491 } }, // Savarkundla Road
  { locationCoordinates: { lat: 21.5927165, lng: 71.2189057 } }, // Station Area
  { locationCoordinates: { lat: 21.6019854, lng: 71.2267713 } }, // Bus Stand Area
  { locationCoordinates: { lat: 21.5903482, lng: 71.2234146 } }, // Market Yard
  { locationCoordinates: { lat: 22.7273983, lng: 71.6480532 } }, // Surendranagar City Center
  { locationCoordinates: { lat: 22.7354186, lng: 71.6529874 } }, // Wadhwan Road
  { locationCoordinates: { lat: 22.7201769, lng: 71.6582163 } }, // Dudheshwar Area
  { locationCoordinates: { lat: 22.7329854, lng: 71.6367451 } }, // Malhar Road
  { locationCoordinates: { lat: 22.7426918, lng: 71.6442077 } }, // GIDC Area
  { locationCoordinates: { lat: 22.7189436, lng: 71.6465392 } }, // Railway Station Area
  { locationCoordinates: { lat: 22.7265047, lng: 71.6569843 } }, // Ambedkar Nagar
  { locationCoordinates: { lat: 22.7390159, lng: 71.6408736 } }, // Vivekanand Nagar
  { locationCoordinates: { lat: 22.7231745, lng: 71.6332914 } }, // Old City Area
  { locationCoordinates: { lat: 22.7315894, lng: 71.6504418 } },

  { locationCoordinates: { lat: 23.0157194, lng: 71.1783562 } }, // Halvad City Center
  { locationCoordinates: { lat: 23.0208647, lng: 71.1847293 } }, // Bus Stand Area
  { locationCoordinates: { lat: 23.0095382, lng: 71.1914638 } }, // Railway Station Area
  { locationCoordinates: { lat: 23.0243169, lng: 71.1720486 } }, // Sardar Nagar
  { locationCoordinates: { lat: 23.0062814, lng: 71.1693345 } }, // Market Area
  { locationCoordinates: { lat: 23.0129756, lng: 71.1864029 } }, // Residential Area
  { locationCoordinates: { lat: 23.0278431, lng: 71.1807164 } }, // Industrial Area
  { locationCoordinates: { lat: 23.0184719, lng: 71.1662898 } }, // Old Halvad
];

export default rawData;
